var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4","lg":"4","xl":"4"}},[_c('span',{staticClass:"text-header-data"},[_vm._v(" Adjuntar Contrato ")]),_c('br'),_c('span',{staticClass:"text-data-details"},[_vm._v(" "+_vm._s(_vm.ramoData.contratoAdjunto ? _vm.ramoData.contratoAdjunto : "Sin llenar")+" ")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }